import React from "react";

/** When true (LazyPageShell), Footer renders HomeDepthCta above the footer chrome. */
export const JstShellContext = React.createContext({
  showDepthCta: false,
});
